import type { APInvoice } from '@erp/rpc';

/** Draft / matched invoices — evaluation needs no email lineage. */
export function reevaluableInvoices<T extends Pick<APInvoice, 'status'>>(
  invoices: readonly T[],
): T[] {
  return invoices.filter(
    (invoice) => invoice.status === 'DRAFT' || invoice.status === 'MATCHED',
  );
}
